module.exports = __webpack_public_path__ + "media/images/insta-logo-grey-54861d33.png";